import React, { type JSX } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { hexColors } from '@mobi/settings/hexColors'
import { dayjs } from '@mobi/utils/date'
import { AppRoutes } from '@core/AppRoutes'
import { MainContainer } from '@core/Components/Containers'

export const TippingPage = (): JSX.Element | null => {
  const location = useLocation()
  const navigate = useNavigate()

  const isShowingResults = /\/results/i.test(location.pathname)

  return (
    <MainContainer style={{ backgroundColor: hexColors.whiteSmoke }}>
      <PageHeader title='Tipping' />

      <Tabs>
        <TabButton
          content='Current'
          onClick={() => navigate(AppRoutes.Tipping)}
          isSelected={!isShowingResults}
        />

        <TabButton
          content='Results'
          onClick={() => navigate(`results?date=${dayjs().format('YYYY-MM-DD')}`)}
          isSelected={isShowingResults}
        />
      </Tabs>

      <Outlet />
    </MainContainer>
  )
}
